import { createEmojiIcon } from '../EmojiIcon';

export const HomeIcon = createEmojiIcon('🏠');
export const SearchIcon = createEmojiIcon('🔍');
export const TimelineIcon = createEmojiIcon('📈');
export const AssignmentIcon = createEmojiIcon('📋');
export const PeopleIcon = createEmojiIcon('👥');
export const MapIcon = createEmojiIcon('🗺️');
export const CategoryIcon = createEmojiIcon('🗂️');
export const CalendarMonthIcon = createEmojiIcon('📅');
export const EventNoteIcon = createEmojiIcon('📝');
export const SettingsIcon = createEmojiIcon('⚙️');
export const AdminPanelSettingsIcon = createEmojiIcon('🛡️');
export const LightModeIcon = createEmojiIcon('☀️');
export const DarkModeIcon = createEmojiIcon('🌙');
export const PaletteIcon = createEmojiIcon('🎨');
export const LogoutIcon = createEmojiIcon('🚪');
